import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { getProjects } from '../lib/api';

export default function Portfolio() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    getProjects().then(setProjects).catch(() => setProjects([]));
  }, []);

  return (
    <section id="portfolio" className="relative py-24 md:py-40 bg-bone" data-testid="portfolio-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex items-baseline justify-between mb-16 md:mb-24">
          <h2 className="serif tracking-tighter text-[11vw] md:text-[6vw] leading-none">
            Selected <span className="italic">work</span>
          </h2>
          <span className="hidden md:block font-sans text-xs uppercase tracking-[0.3em] text-graphite max-w-[220px] text-right">
            Results-first. Anonymized where needed, never fabricated.
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6 md:gap-8">
          {projects.map((p, i) => {
            const large = p.span === 'large';
            return (
              <motion.article
                key={p.id || i}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.7, delay: (i % 2) * 0.1 }}
                className={`group relative overflow-hidden bg-paper ${
                  large ? 'md:col-span-2 lg:col-span-7 lg:row-span-2' : 'lg:col-span-5'
                }`}
                data-testid={`project-${i}`}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className={`w-full object-cover transition-transform duration-700 ease-cinematic group-hover:scale-105 ${
                      large ? 'h-[300px] md:h-[420px] lg:h-[520px]' : 'h-[280px] md:h-[340px]'
                    }`}
                  />
                  <div className="absolute top-4 left-4 flex gap-2">
                    <span className="px-3 py-1 bg-obsidian/80 backdrop-blur text-bone font-sans text-[10px] uppercase tracking-[0.2em]">
                      {p.discipline}
                    </span>
                  </div>
                </div>
                <div className="p-6 md:p-8">
                  <div className="flex items-baseline justify-between mb-3">
                    <h3 className="serif text-3xl md:text-4xl tracking-tight">{p.title}</h3>
                    <span className="font-sans text-xs uppercase tracking-[0.2em] text-graphite">
                      {p.industry}
                    </span>
                  </div>
                  <p className="font-sans text-sm text-graphite mb-2">
                    <span className="text-obsidian">Challenge —</span> {p.challenge}
                  </p>
                  <p className="font-sans text-sm text-graphite mb-4">
                    <span className="text-obsidian">Solution —</span> {p.solution}
                  </p>
                  <div className="serif italic text-2xl text-signal">{p.outcome}</div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
